import z from "zod";
const usFullAddressFormValidationSchema = z.object({
  addressLine1: z.string().regex(/^.+$/),
  addressLine2: z.string().optional(),
  zipCode: z.string().regex(/^\d{5}(?:[-\s]\d{4})?$/)
});
const toBoolean = (value) => {
  if (value === void 0 || value === "false" || value === "") {
    return false;
  }
  return value.toLowerCase() === "true";
};
export {
  toBoolean,
  usFullAddressFormValidationSchema
};
